import { useEffect } from "react";
import { useHeader } from "../contexts/HeaderContext";
import { useView } from "../contexts/ViewContext";

export const PlanSync = () => {
    const { view, learningJourneyId } = useView();
    const { setJourney } = useHeader();

    useEffect(() => {
        setJourney(
            view?.plan
                ? { id: learningJourneyId, title: view.plan.title, viewType: view.view_type }
                : null
        );
    }, [view, learningJourneyId, setJourney]);

    return null; // this component doesn't render anything
}
